module.exports = __webpack_public_path__ + "./fonts/flame-regular.ttf";